<div *ngIf="_actionGroup" [class]="classNames">
    <sh-action-item
        *ngFor="let item of _actionGroup.actions"
        [inOverflownContainer]="inOverflownContainer"
        [class]="groupItemClassNames"
        [bubbleEvent]="bubbleEvent"
        [item]="item"
        [childComponentClasses]="childComponentClasses"
    >
    </sh-action-item>
</div>
